
import { School } from '@/models/academy.types';
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";

@Component
export default class CheckSchoolName extends Vue {
  // ACTION
  @Action('actionLoadSchool', { namespace: 'misc'})
  private actionLoadSchool: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: any;
  @State("array_school", { namespace: "misc" })
  private array_school: any[];

  // WATCH
  @Watch('school.name')
  private onChangeSchoolName(name: string) {
    if (name != null) {
      localStorage.setItem("school_name", name);
    }
  }
  // LIFECYCLE
  private created() {
    const school_name = localStorage.getItem("school_name");
    if (school_name != null) {
      this.$store.state.academy.school.name = school_name;
    }
  }


  private onInputSchoolName(school: any) {
    if (school.hasOwnProperty('name')) {
      this.school.name = school.name;
    } else {
      this.school.name = school;
    }
  }

  private onSearchSchool(value: any, toggleLoading: any) {
    toggleLoading();
    this.actionLoadSchool({
      params: {
        schooltype: this.school.school_type.id,
        search: value,
      },
      success: (response: any) => {
        toggleLoading();
      },
      fail: (response: any) => {
        toggleLoading();
      },
    });
  }

  private createNewSchool(search: any) {
    const value = {
      branch: null,
      city: null,
      id: search,
      name: search,
      school_type: null,
    };
    this.array_school.push(value);
    this.school.name = search
    this.$refs['selectSchool'].typeAheadSelect();
  }
}
